/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

import * as constants from 'constants/Invoice'

const SALARY_REPORT_LIST_URL = '/api/salary/report/list/'
const SALARY_PROVISIONAL_REPORT_LIST_URL = '/api/salary/provisional/report/list/'
const ORDER_REPORT_LIST_URL = '/api/order/report/list/'
const SALARY_DATE_LIST_URL = '/api/salary/date/list/'
const SALARY_PROVISIONAL_DATE_LIST_URL = '/api/salary/provisional/date/list/'
const SALARY_REPORT_PDF_URL = '/api/salary/report/pdf/'

export function getInvoices(query, type) {
  let url = ''

  query = {
    ...query,
    meta: false,
    objects_count: false,
  }

  if (type === constants.FACTURATION) {
    url = ORDER_REPORT_LIST_URL
  } else if (type === constants.REMUNERATION) {
    url = SALARY_REPORT_LIST_URL
  } else {
    url = SALARY_PROVISIONAL_REPORT_LIST_URL
  }

  url +=  '?' + qs.stringify(query)
  console.log(url)

  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_URL + url
  }

  return url
}

export function getSalaryDates (query) {
  return Request.getRequest(SALARY_DATE_LIST_URL + '?' + qs.stringify(query))
}

export function getProvisionalSalaryDates (query) {
  return Request.getRequest(SALARY_PROVISIONAL_DATE_LIST_URL + '?' + qs.stringify(query))
}

export function getSalaryReportPdf (query) {
  return Request.getRequest(SALARY_REPORT_PDF_URL + '?' + qs.stringify(query))
}



// WEBPACK FOOTER //
// ./src/actions/Invoice.js